/** Bound image IPC requests without retaining completed image data. */
export class ThumbnailReadQueue {
  private active = 0;
  private pending = new Set<() => Promise<void>>();
  private readonly concurrency: number;
  constructor(concurrency = 4) {
    if (!Number.isInteger(concurrency) || concurrency < 1)
      throw new Error('Invalid thumbnail concurrency');
    this.concurrency = concurrency;
  }
  schedule(read: () => Promise<void>): () => void {
    this.pending.add(read);
    this.drain();
    // In-flight IPC cannot be aborted; its owner ignores disposed responses.
    // Queued requests are removed entirely, not retained until their turn.
    return () => {
      this.pending.delete(read);
    };
  }
  private drain(): void {
    while (this.active < this.concurrency && this.pending.size) {
      const read = this.pending.values().next().value!;
      this.pending.delete(read);
      this.active++;
      void Promise.resolve()
        .then(read)
        .catch(() => undefined)
        .finally(() => {
          this.active--;
          this.drain();
        });
    }
  }
}
export const thumbnailReads = new ThumbnailReadQueue();
